import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

export const anchorId = (text) =>
  (text || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const split = (html) => {
  const root = new DOMParser().parseFromString(`<div>${html || ""}</div>`, "text/html").body.firstChild;
  const out = [];
  let cur = { title: null, html: "" };
  [...root.childNodes].forEach((node) => {
    if (node.nodeName === "H2") {
      if (cur.title || cur.html.trim()) out.push(cur);
      cur = { title: node.textContent, html: "" };
      return;
    }
    const wrap = document.createElement("div");
    wrap.appendChild(node.cloneNode(true));
    cur.html += wrap.innerHTML;
  });
  if (cur.title || cur.html.trim()) out.push(cur);
  return out;
};

export const PageBody = ({ html }) => {
  const navigate = useNavigate();
  const sections = useMemo(() => split(html), [html]);
  const onClick = (e) => {
    const a = e.target.closest("a");
    const href = a?.getAttribute("href");
    if (href?.startsWith("/") && !href.startsWith("/api/") && !a.target) {
      e.preventDefault();
      navigate(href);
    }
  };
  return (
    <div onClick={onClick} data-testid="page-body">
      {sections.map((s, i) =>
        s.title ? (
          <section key={i} id={anchorId(s.title)} className="grid md:grid-cols-12 gap-6 border-t border-border py-10 scroll-mt-20" data-testid={`page-section-${i}`}>
            <h2 className="md:col-span-4 font-display font-black text-2xl sm:text-3xl tracking-tight leading-tight">{s.title}</h2>
            <div className="md:col-span-8 article-body space-y-4 min-w-0 break-words" dangerouslySetInnerHTML={{ __html: s.html }} />
          </section>
        ) : (
          <div key={i} className="article-body max-w-3xl py-6 break-words" dangerouslySetInnerHTML={{ __html: s.html }} />
        )
      )}
    </div>
  );
};
